import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ParticipantsDialog.css';
import './GatheringsSidebar.css';

function SendStarDialog({ recipient, giveawayStars, onClose, onSubmit }) {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  return (
    <div className="participants-dialog-overlay" onClick={onClose}>
      <div className="participants-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h4>{t('sendStarDialog.title', { name: recipient.user.displayName })}</h4>
          <button className="close-dialog" onClick={onClose}>×</button>
        </div>

        <div className="star-modal-content">
          <div className="star-info">
            <p className="star-explanation">
              {t('sendStarDialog.starsAvailable', { count: giveawayStars })}
            </p>
            {giveawayStars === 1 && (
              <p className="last-star-warning">
                {t('sendStarDialog.lastStarWarning')}
              </p>
            )}
            <p className="star-hint">
              {t('sendStarDialog.hint')}
            </p>
          </div>

          <div className="form-group">
            <label>{t('sendStarDialog.messageLabel')}</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t('sendStarDialog.messagePlaceholder')}
              className="star-message-input"
              rows="3"
              maxLength="200"
            />
            <p className="char-count">{message.length}/200</p>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isAnonymous}
                onChange={(e) => setIsAnonymous(e.target.checked)}
                className="anonymous-checkbox"
              />
              <span className="checkbox-text">{t('sendStarDialog.anonymousLabel')}</span>
            </label>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isPrivate}
                onChange={(e) => setIsPrivate(e.target.checked)}
                className="anonymous-checkbox"
              />
              <span className="checkbox-text">{t('sendStarDialog.privateLabel')}</span>
            </label>
          </div>

          <div className="star-modal-actions">
            <button className="cancel-btn" onClick={onClose}>
              {t('common.cancel')}
            </button>
            <button
              className="confirm-btn"
              onClick={() => onSubmit(message.trim() || null, isAnonymous, isPrivate)}
            >
              {t('sendStarDialog.submit')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendStarDialog;
